import { render } from "./DeleteAcc.vue?vue&type=template&id=74831922&scoped=true&ts=true"
import script from "./DeleteAcc.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeleteAcc.vue?vue&type=script&setup=true&lang=ts"

import "./DeleteAcc.vue?vue&type=style&index=0&id=74831922&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74831922"],['__file',"src/views/vault/DeleteAcc.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74831922"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74831922', __exports__)) {
    console.log('reload')
    api.reload('74831922', __exports__)
  }
  
  module.hot.accept("./DeleteAcc.vue?vue&type=template&id=74831922&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('74831922', render)
  })

}


export default __exports__